import React from 'react';
import { useSelector } from 'react-redux';
import { round6 } from 'utilities/math';

import Table from 'components/Table';

import { ITALIC_P } from 'scenes/InferentialStatistics/Constants';

import {
  getTableData,
  getConfidenceInterval,
  getCategoricalRowDataSet,
  getLevelsRowDataSet,
  getLimits
} from 'store/scenes/inferentialStatistics/selectors';

import { getTableHeadersOneSampleProportion } from 'scenes/InferentialStatistics/RightPane/Procedures/shared';

const OneSimpleProportionConfidenceInterval = () => {
  const { lowerLimit, upperLimit } = useSelector(state => getLimits(state));
  const tableData = useSelector(state => getTableData(state));
  const confidenceInterval = useSelector(state => getConfidenceInterval(state));
  const isVariableChosen = useSelector(state => getCategoricalRowDataSet(state));
  const isLevelChosen = useSelector(state => getLevelsRowDataSet(state));

  const tableHeaders = getTableHeadersOneSampleProportion(isVariableChosen, isLevelChosen);

  return (
    <div className="content-item">
      <h3 className="mb-20">One Sample Proportion Confidence Interval Summary</h3>
      <span className="font-900 font-16 mb-15 ml-5">
        {ITALIC_P}: proportion of successes in population
      </span>
      <span className="mr-5 mb-20">
        {confidenceInterval}% Confidence Interval for {ITALIC_P}
      </span>
      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>Lower Limit </td>
            <td>
              <span>{round6(lowerLimit)}</span>
            </td>
          </tr>
          <tr>
            <td>Upper Limit </td>
            <td>
              <span>{round6(upperLimit)}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeaders} tableData={tableData} />
    </div>
  );
};

export default OneSimpleProportionConfidenceInterval;
